import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "advanced-analytics" };
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4" };
const _hoisted_3 = { class: "d-flex gap-2" };
const _hoisted_4 = ["disabled"];
const _hoisted_5 = { class: "card border-0 shadow-sm mb-4" };
const _hoisted_6 = { class: "card-body p-4" };
const _hoisted_7 = { class: "row g-3 align-items-end" };
const _hoisted_8 = { class: "col-md-4" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "col-md-3" };
const _hoisted_11 = { class: "col-md-3" };
const _hoisted_12 = { class: "col-md-2" };
const _hoisted_13 = ["disabled"];
const _hoisted_14 = {
    key: 0,
    class: "py-5 text-center"
};
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { class: "row mb-4" };
const _hoisted_17 = { class: "col-md-3" };
const _hoisted_18 = { class: "card border-0 shadow-sm bg-primary text-white h-100" };
const _hoisted_19 = { class: "card-body" };
const _hoisted_20 = { class: "fw-bold mb-0" };
const _hoisted_21 = { class: "col-md-3" };
const _hoisted_22 = { class: "card border-0 shadow-sm h-100" };
const _hoisted_23 = { class: "card-body" };
const _hoisted_24 = { class: "fw-bold mb-0 text-black" };
const _hoisted_25 = { class: "mt-2 text-success small" };
const _hoisted_26 = { class: "col-md-3" };
const _hoisted_27 = { class: "card border-0 shadow-sm h-100" };
const _hoisted_28 = { class: "card-body" };
const _hoisted_29 = { class: "fw-bold mb-0 text-info" };
const _hoisted_30 = { class: "col-md-3" };
const _hoisted_31 = { class: "card border-0 shadow-sm h-100" };
const _hoisted_32 = { class: "card-body" };
const _hoisted_33 = { class: "fw-bold mb-0 text-warning" };
const _hoisted_34 = { class: "row g-4 mb-4" };
const _hoisted_35 = { class: "col-lg-4 col-md-6" };
const _hoisted_36 = { class: "card border-0 shadow-sm h-100" };
const _hoisted_37 = { class: "card-body px-4 pb-4" };
const _hoisted_38 = { class: "col-lg-8 col-md-6" };
const _hoisted_39 = { class: "card border-0 shadow-sm h-100" };
const _hoisted_40 = { class: "card-body px-4 pb-4" };
const _hoisted_41 = { class: "col-12" };
const _hoisted_42 = { class: "card border-0 shadow-sm" };
const _hoisted_43 = { class: "card-body px-4 pb-4" };
const _hoisted_44 = { class: "col-md-6" };
const _hoisted_45 = { class: "card border-0 shadow-sm h-100" };
const _hoisted_46 = { class: "card-body p-0" };
const _hoisted_47 = { class: "table-responsive" };
const _hoisted_48 = { class: "table table-hover align-middle mb-0" };
const _hoisted_49 = { class: "ps-4 fw-medium" };
const _hoisted_50 = { class: "text-center" };
const _hoisted_51 = { class: "text-end pe-4 fw-bold" };
const _hoisted_52 = { class: "col-md-6" };
const _hoisted_53 = { class: "card border-0 shadow-sm h-100" };
const _hoisted_54 = { class: "card-body p-0" };
const _hoisted_55 = { class: "table-responsive" };
const _hoisted_56 = { class: "table table-hover align-middle mb-0" };
const _hoisted_57 = { class: "ps-4 fw-medium" };
const _hoisted_58 = ["title"];
const _hoisted_59 = { class: "text-center" };
const _hoisted_60 = { class: "text-end pe-4 fw-bold text-primary" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_apexchart = _resolveComponent("apexchart");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "fw-bold text-black mb-0" }, "Rapports & Analytiques Avancés", -1)),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.downloadCsv && _ctx.downloadCsv(...args))),
                    class: "btn btn-outline-success d-flex align-items-center gap-2",
                    disabled: _ctx.isExporting
                }, [
                    _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-download-2-line" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.isExporting ? 'Export en cours...' : 'Exporter CSV'), 1)
                ], 8, _hoisted_4)
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label small fw-bold text-muted" }, "RESTAURANT", -1)),
                        _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.filters.restaurantId) = $event)),
                            class: "form-select shadow-none border-light-subtle"
                        }, [
                            _cache[7] || (_cache[7] = _createElementVNode("option", { value: "all" }, "Tous les restaurants", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurants, (res) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: res.id,
                                    value: res.id
                                }, _toDisplayString(res.name), 9, _hoisted_9));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, _ctx.filters.restaurantId]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label small fw-bold text-muted" }, "DU", -1)),
                        _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.filters.startDate) = $event)),
                            class: "form-control shadow-none border-light-subtle"
                        }, null, 512), [
                            [_vModelText, _ctx.filters.startDate]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label small fw-bold text-muted" }, "AU", -1)),
                        _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.filters.endDate) = $event)),
                            class: "form-control shadow-none border-light-subtle"
                        }, null, 512), [
                            [_vModelText, _ctx.filters.endDate]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.fetchAnalytics && _ctx.fetchAnalytics(...args))),
                            class: "btn btn-primary w-100 py-2",
                            disabled: _ctx.isLoading
                        }, [
                            _createElementVNode("i", {
                                class: _normalizeClass(["ri-refresh-line me-1", { 'ri-spin': _ctx.isLoading }])
                            }, null, 2),
                            _cache[11] || (_cache[11] = _createTextVNode(" Actualiser ", -1))
                        ], 8, _hoisted_13)
                    ])
                ])
            ])
        ]),
        (_ctx.isLoading && !_ctx.analyticsData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("div", {
                        class: "spinner-border text-primary",
                        role: "status"
                    }, null, -1),
                    _createElementVNode("p", { class: "mt-2 text-muted" }, "Chargement de l'intelligence commerciale...", -1)
                ]))]))
            : (_ctx.analyticsData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "small opacity-75 mb-1" }, "Chiffre d'Affaire Total", -1)),
                                    _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.formatPrice(_ctx.totalRevenue)), 1),
                                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mt-2 text-white-50 small" }, "Sur la période sélectionnée", -1))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "small text-muted mb-1 font-inter" }, "Panier Moyen", -1)),
                                    _createElementVNode("h2", _hoisted_24, _toDisplayString(_ctx.formatPrice(_ctx.averageBasket)), 1),
                                    _createElementVNode("div", _hoisted_25, [
                                        _cache[15] || (_cache[15] = _createElementVNode("i", { class: "ri-arrow-right-line" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.totalOrders) + " Commandes ", 1)
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _cache[17] || (_cache[17] = _createElementVNode("p", { class: "small text-muted mb-1" }, "Attach Rate (Boissons)", -1)),
                                    _createElementVNode("h2", _hoisted_29, _toDisplayString((_ctx.analyticsData?.attachRate?.drinks || 0).toFixed(1)) + "%", 1),
                                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mt-2 text-muted small" }, "Clients ayant pris une boisson", -1))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                    _cache[19] || (_cache[19] = _createElementVNode("p", { class: "small text-muted mb-1" }, "Taux de Rétention", -1)),
                                    _createElementVNode("h2", _hoisted_33, _toDisplayString(_ctx.retentionRate) + "%", 1),
                                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mt-2 text-muted small" }, "Clients récurrents", -1))
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "card-header bg-transparent border-0 pt-4 px-4" }, [
                                    _createElementVNode("h5", { class: "fw-bold text-black mb-0" }, "Répartition par Canal")
                                ], -1)),
                                _createElementVNode("div", _hoisted_37, [
                                    _createVNode(_component_apexchart, {
                                        type: "donut",
                                        height: "300",
                                        options: _ctx.platformOptions,
                                        series: _ctx.platformSeries
                                    }, null, 8, ["options", "series"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-header bg-transparent border-0 pt-4 px-4" }, [
                                    _createElementVNode("h5", { class: "fw-bold text-black mb-0" }, "Performance par Zone (Code Postal)")
                                ], -1)),
                                _createElementVNode("div", _hoisted_40, [
                                    _createVNode(_component_apexchart, {
                                        type: "bar",
                                        height: "300",
                                        options: _ctx.zipOptions,
                                        series: _ctx.zipSeries
                                    }, null, 8, ["options", "series"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "card-header bg-transparent border-0 pt-4 px-4 d-flex justify-content-between align-items-center" }, [
                                    _createElementVNode("h5", { class: "fw-bold text-black mb-0" }, "Heures de Pointe (Intensité des Ventes)"),
                                    _createElementVNode("span", { class: "badge bg-light text-dark fw-normal rounded-pill px-3" }, "Par heure de la journée")
                                ], -1)),
                                _createElementVNode("div", _hoisted_43, [
                                    _createVNode(_component_apexchart, {
                                        type: "heatmap",
                                        height: "250",
                                        options: _ctx.heatmapOptions,
                                        series: _ctx.heatmapSeries
                                    }, null, 8, ["options", "series"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "card-header bg-transparent border-0 pt-4 px-4" }, [
                                    _createElementVNode("h5", { class: "fw-bold text-black mb-0" }, "Top 5 Produits (en CA)")
                                ], -1)),
                                _createElementVNode("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("table", _hoisted_48, [
                                            _cache[24] || (_cache[24] = _createElementVNode("thead", { class: "bg-light small" }, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", { class: "ps-4" }, "Produit"),
                                                    _createElementVNode("th", { class: "text-center" }, "Quantité"),
                                                    _createElementVNode("th", { class: "text-end pe-4" }, "Revenu généré")
                                                ])
                                            ], -1)),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.analyticsData?.products || []), (prod) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: prod.name
                                                    }, [
                                                        _createElementVNode("td", _hoisted_49, _toDisplayString(prod.name), 1),
                                                        _createElementVNode("td", _hoisted_50, _toDisplayString(prod.count), 1),
                                                        _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.formatPrice(prod.revenue)), 1)
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "card-header bg-transparent border-0 pt-4 px-4" }, [
                                    _createElementVNode("h5", { class: "fw-bold text-black mb-0" }, "Top 5 Clients (Fidélité)")
                                ], -1)),
                                _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("table", _hoisted_56, [
                                            _cache[26] || (_cache[26] = _createElementVNode("thead", { class: "bg-light small" }, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", { class: "ps-4" }, "ID Client / Nom"),
                                                    _createElementVNode("th", { class: "text-center" }, "Commandes"),
                                                    _createElementVNode("th", { class: "text-end pe-4" }, "Dépense Totale")
                                                ])
                                            ], -1)),
                                            _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.analyticsData?.customers?.topClients?.slice(0, 5) || []), (cust) => {
                                                    return (_openBlock(), _createElementBlock("tr", {
                                                        key: cust.id
                                                    }, [
                                                        _createElementVNode("td", _hoisted_57, [
                                                            _createElementVNode("div", {
                                                                class: "text-truncate",
                                                                style: { "max-width": "200px" },
                                                                title: cust.name || '---'
                                                            }, _toDisplayString(cust.name || '---'), 9, _hoisted_58)
                                                        ]),
                                                        _createElementVNode("td", _hoisted_59, _toDisplayString(cust.orderCount), 1),
                                                        _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.formatPrice(cust.totalAmount)), 1)
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true)
    ]));
}
